// E10 voucher disposition (R-M / R-M2): ONE section listing each live voucher use the change touches. A usable voucher is RESTORED by default (no blocking question; "void it instead" is a switch);
// an unusable one needs a choice: replacement voucher (a new expiry date when the original expired) | write off. Used by cancel order, return and the value edit.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../inputs/Input';
import { M } from '../../../pages/Sales/orderPage/orderPageBits.jsx';
import { localToday } from '../../../pages/Sales/invoicing/invoicingModel.mjs';
import { usesOf, choiceOf, isExpired } from './voucherDispoModel.mjs';

function UseCard({ u, pk, onChange }) {
  const { t } = useTranslation('orderPage'); const today = localToday(); const choice = choiceOf(u, { [u.use_id]: pk });
  const expired = isExpired(u, today); const opts = u.options || (u.usable ? ['restore', 'void'] : ['replacement', 'writeoff']);
  const set = (c) => onChange({ choice: c });
  return (
    <div className="field np-fd-card" data-testid={`vd-use-${u.use_id}`}>
      <div className="lab">{t('vdispo.voucher', { no: u.voucher_no || u.voucher_id })} . {M(u.amount)}{u.expires_on ? <span className="sub"> . {t('vdispo.expires', { date: u.expires_on })}</span> : null}</div>
      {u.usable
        ? <label className="np-fd-opt"><input type="checkbox" data-testid="vd-void" checked={choice === 'void'} onChange={e => set(e.target.checked ? 'void' : 'restore')} /> {t('vdispo.voidInstead')}</label>
        : null}
      {u.usable && choice === 'restore' && <div className="sub" data-testid="vd-restored">{t('vdispo.restored')}</div>}
      {choice === 'restore' && u.nets_dues && !/^0*(\.0*)?$/.test(u.nets_dues) && <div className="sub" data-testid="vd-netted">{t('vdispo.netted', { nets: M(u.nets_dues), restores: M(u.restores) })}</div>}   {/* 994 (R-AS D2): the voucher pays the dues the cancel keeps first */}
      {!u.usable && (<fieldset className="np-fd-set">
        <legend className="sub" role="note">{expired ? t('vdispo.expiredAsk') : t('vdispo.unusableAsk')}</legend>
        {opts.map(c => <label key={c} className="np-fd-opt"><input type="radio" name={`vd-${u.use_id}`} data-testid={`vd-${c}`} checked={choice === c} onChange={() => set(c)} /> {t('vdispo.opt.' + c)}</label>)}
        {choice === 'replacement' && expired && (<div className="field">
          <label className="lab" htmlFor={`vd-exp-${u.use_id}`}>{t('vdispo.newExpiry')}</label>
          <TextInput id={`vd-exp-${u.use_id}`} type="date" data-testid="vd-expiry" min={today} disabled={pk.expires_on === null} value={pk.expires_on || ''} onChange={e => onChange({ choice: 'replacement', expires_on: e.target.value || undefined })} />
          <label className="np-fd-opt"><input type="checkbox" data-testid="vd-noexpiry" checked={pk.expires_on === null} onChange={e => onChange({ choice: 'replacement', expires_on: e.target.checked ? null : undefined })} /> {t('vdispo.noExpiry')}</label>
        </div>)}
      </fieldset>)}
      {u.replacement && <div className="sub" data-testid="vd-replacement">{t('vdispo.replaced', { no: u.replacement.voucher_no || u.replacement.voucher_id })}</div>}
    </div>
  );
}

export default function VoucherDispositionSection({ plan, picked, onChange }) {
  const { t } = useTranslation('orderPage'); const uses = usesOf(plan);
  if (!uses.length) return null;
  return (
    <section data-testid="vd-section" aria-label={t('vdispo.title')}>
      <div className="sec-lab">{t('vdispo.title')}</div>
      <div className="sub np-vd-hint">{t('vdispo.hint')}</div>
      {uses.map(u => <UseCard key={u.use_id} u={u} pk={picked[u.use_id] || {}} onChange={next => onChange({ ...picked, [u.use_id]: next })} />)}
    </section>
  );
}
